import axios from 'axios'

const sendData = (payload, host) =>
  axios.put(`${host}/service/communication/v1/channel/${payload.channel.id}/communication/${payload.id}`,
    JSON.stringify(payload),
    {
      headers: {
        'content-type': 'application/json',
        'accept': 'application/json',
        'withCredentials': true
      }
    }
  )

const sendWebcastDataCancel = (data, host = '') => {

  return sendData(data, host)

}

export default sendWebcastDataCancel
